import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { useForm } from "react-hook-form";

// GET - POST - PUT
import useAxios from "../../../request/useAxios";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp(props) {
  const { setSignup } = props.useSignup;
  const { setAlert } = props.useAlert;
  const [state, setState] = React.useState({
    gender: ''
  });
  const { post } = useAxios();
  const { register, errors, handleSubmit } = useForm();
  const classes = useStyles();

  const currentDate = new Date().toISOString().slice(0, 10);

  function handleLogupSubmit(e) {
    e.preventDefault();
    setSignup(false);
  }

  const handleChange = (e) => {
    const name = e.target.name;
    setState({
      ...state,
      [name]: e.target.value,
    });
  };

  const handleFormSubmit = (e) => {
    if (e) {
      // POST login
      e.registrationType = "salesmanRegistration";
      const data = JSON.stringify(e);
      console.log(data);
      post(
        `/registration/`,
        data,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then((data) => {
          // console.log("re:", e);
          setAlert(true);
          setSignup(false);
          // localStorage.setItem("TS", JSON.stringify({ token: data.token, userId: data.userId }));
          // user.auth = data;
        })
        .catch((error) => console.log("Could not load user", error));
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Regisztráció
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit(handleFormSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <TextField
                autoComplete="uname"
                name="username"
                variant="outlined"
                required
                fullWidth
                id="username"
                label="Felhasználónév"
                autoFocus
                type="text"
                inputRef={
                  register(
                    {
                      required: "Kötelező",
                      minLength: {
                        value: 6,
                        message: "Minimum 6 karakter"
                      },
                      pattern: {
                        value: /^[A-Za-z0-9-]+(?:[ _][A-Za-z0-9-]+)*$/,
                        message: 'Csak ékezet nélküli kis és nagy betű, és - használható' // JS only: <p>error message</p> TS only support string
                      }
                    }
                  )
                }
                error={errors.username}
                helperText={errors.username && errors.username.message}
              />
              {console.log(errors)}
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email cím"
                name="email"
                autoComplete="emailA"
                type="email"
                inputRef={
                  register(
                    {
                      required: "Kötelező",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Hibás e-mail cím"
                      }
                    }
                  )
                }
                error={errors.email}
                helperText={errors.email && errors.email.message}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Jelszó"
                type="password"
                id="password"
                autoComplete="passwordA"
                inputRef={register({ required: true })}
                error={errors.password}
                helperText={errors.password && 'Kötelező megadni'}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid >
            <Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="lastnme"
                label="Családnév"
                name="lastname"
                autoComplete="lastnameA"
                type="text"
                inputRef={register({ required: true })}
                error={errors.lastname}
                helperText={errors.lastname && 'Kötelező'}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                autoComplete="middleNameA"
                name="middleName"
                variant="outlined"
                required
                fullWidth
                id="middleName"
                label="Középső név"
                type="text"
                inputRef={register({ required: true })}
                error={errors.middleName}
                helperText={errors.middleName && 'Kötelező'}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                autoComplete="firstnameA"
                name="firstname"
                variant="outlined"
                required
                fullWidth
                id="firstname"
                label="Keresztnév"
                type="text"
                inputRef={register({ required: true })}
                error={errors.firstname}
                helperText={errors.firstname && 'Kötelező'}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="phoneNumber"
                label="Telefonszám"
                name="phoneNumber"
                autoComplete="phoneNumberA"
                type="number"
                inputRef={
                  register(
                    {
                      required: 'Kötelező megadni'
                    }
                  )
                }
                error={errors.phoneNumber}
                helperText={errors.phoneNumber && errors.phoneNumber.message}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="nationality"
                label="Nemzetiség"
                name="nationality"
                autoComplete="nationalityA"
                type="text"
                inputRef={register({ required: true })}
                error={errors.nationality}
                helperText={errors.nationality && 'Kötelező megadni'}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="country"
                label="Ország"
                name="country"
                autoComplete="countryA"
                type="text"
                inputRef={register({ required: true })}
                error={errors.country}
                helperText={errors.country && 'Kötelező megadni'}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="county"
                label="Megye"
                name="county"
                autoComplete="countyA"
                type="text"
                inputRef={register({ required: true })}
                error={errors.county}
                helperText={errors.county && 'Kötelező megadni'}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="city"
                label="Város"
                name="city"
                autoComplete="cityA"
                type="text"
                inputRef={register({ required: true })}
                error={errors.city}
                helperText={errors.city && 'Kötelező megadni'}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="postcode"
                label="Irányítószám"
                name="postcode"
                autoComplete="postcodeA"
                type="number"
                inputRef={register({ required: true })}
                error={errors.postcode}
                helperText={errors.postcode && 'Kötelező megadni'}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="address"
                label="Cím"
                name="address"
                autoComplete="addressA"
                type="text"
                inputRef={register({ required: true })}
                error={errors.address}
                helperText={errors.address && 'Kötelező megadni'}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="houseNumber"
                label="Házszám"
                name="houseNumber"
                autoComplete="houseNumberA"
                type="number"
                inputRef={register({ required: true })}
                error={errors.houseNumber}
                helperText={errors.houseNumber && 'Kötelező megadni'}
              />
            </Grid>
            <Grid item xs={7}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="birthDate"
                label="Születésnap"
                name="birthDate"
                autoComplete="birthDateA"
                type="date"
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: currentDate }}
                inputRef={register({ required: true })}
                error={errors.birthDate}
                helperText={errors.birthDate && 'Kötelező megadni'}
              />
            </Grid>
            <Grid item xs={5}>
              <FormControl error={errors.gender} variant="outlined" className={classes.formControl} style={{ width: '100%' }}>
                <InputLabel htmlFor="outlined-age-native-simple">Neme</InputLabel>
                <Select
                  native
                  required
                  value={state.gender}
                  onChange={handleChange}
                  label="Neme"
                  name="gender"
                  inputProps={{
                    name: 'gender',
                    id: 'gender',
                  }}
                  inputRef={register({ required: true })}
                  error={errors.gender}
                >
                  <option aria-label="None" value="" />
                  <option value="male">Férfi</option>
                  <option value="female">Nő</option>
                </Select>
                <FormHelperText >{errors.gender && 'Kötelező megadni'}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormControlLabel
                control={<Checkbox
                  value={true}
                  required
                  color="primary"
                  id="drivingLicense"
                  name="drivingLicense"
                  inputRef={register({ required: true })}
                />}
                label="Vezetői engedély"
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid >
            <Grid item xs={12} >
              <FormControl required error={errors.gdpr} >
                <FormControlLabel
                  control={<Checkbox
                    value="true"
                    color="primary"
                    required
                    id="gdpr"
                    name="gdpr"
                    inputRef={register({ required: true })}
                    error={errors.gdpr}
                    helperText={errors.gdpr && 'Kötelező megadni'}
                  />}
                  label="Fiók létrehozásával elfogadja az Általános Szerződési Feltételeket."
                  error={errors.gdpr}
                  required
                />
                <FormHelperText >{errors.gdpr && 'Csak akkor regisztrálhat, ha elfogadja'}</FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Regisztráció
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="#" variant="body2" onClick={handleLogupSubmit}>
                Már van fiókja? Bejelentkezés
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
}